import jsPDF, { jsPDFOptions } from "jspdf";
import { useCallback } from "react";
import html2canvas from "html2canvas";

export const useMakeReceipt = (): {
  makePdf: (
    fileName: string,
    sectionId: string,
    jsPDFConfig?: jsPDFOptions,
  ) => Promise<string | undefined>;
} => {
  const makePdf = useCallback(
    async (fileName: string, sectionId: string, jsPDFConfig?: jsPDFOptions) => {
      const pdf = new jsPDF(
        jsPDFConfig ?? {
          orientation: "p",
          unit: "px",
          format: "a5",
          compress: true,
        },
      );
      const receipt = document.getElementById(`${sectionId}`) as HTMLElement;

      const duplicatedConatainer = receipt.cloneNode(true) as HTMLElement;
      document.body.appendChild(duplicatedConatainer);
      if (duplicatedConatainer) {
        const htmlToCanvas = await html2canvas(duplicatedConatainer, {
          height: duplicatedConatainer.clientHeight,
          width: duplicatedConatainer.clientWidth,
        }).then(async (canvasReceipt) => {
          const dataURL = canvasReceipt.toDataURL("image/png");
          const pdfWidth = pdf.internal.pageSize.width;
          const pdfHeight = pdf.internal.pageSize.height;

          const receiptProportionOfPdf = 3 / 4;
          const receiptRatio =
            duplicatedConatainer.clientWidth /
            duplicatedConatainer.clientHeight;
          const receiptWidth = pdfWidth * receiptProportionOfPdf;
          const receiptHeight = receiptWidth / receiptRatio;

          canvasReceipt.width = receiptWidth;
          canvasReceipt.height = receiptHeight;

          pdf.setFillColor("#ffffff");
          pdf.rect(0, 0, pdfWidth, pdfHeight, "F");
          pdf.addImage(
            dataURL,
            "PNG",
            (pdfWidth - receiptWidth) / 2,
            24,
            receiptWidth,
            receiptHeight,
          );

          pdf.save(fileName);
          return fileName;
        });
        document.body.removeChild(duplicatedConatainer);
        return htmlToCanvas;
      } else {
        return undefined;
      }
    },
    [],
  );

  return { makePdf };
};
